import { HotTable } from '@handsontable/vue3';
import Handsontable from 'handsontable';
import { App } from 'vue';

import CatalogRecordAmountValidator from 'SharedDir/utils/CatalogRecordAmountValidator';
import EmptyToNullEditor from 'SharedDir/utils/EmptyToNullEditor';

/**
 *
 * @param {App} app
 * @constructor
 */
export const RegisterHandsontable = (app) => {
  app.component('HotTable', HotTable);
  Handsontable.editors.registerEditor('empty-to-null', EmptyToNullEditor);
  Handsontable.validators.registerValidator('catalog-record-amount', CatalogRecordAmountValidator);
};
